import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useFormGeneric from "../../app/hooks/useFormGeneric";
import validate from "../../app/validations/LoginFormValidationRules";
import { useDispatch } from "react-redux";
import { startLogin_Unified } from "../../app/actions/authActions";
import { nanoid } from "nanoid";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { formatToTwoDigits } from "../../app/helpers/formatToTwoDigits";

const initialData = {
  email: "",
  password: "",
};

const LoginOneColumn = () => {
  debugLogPages('---> LoginOneColumn');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [showEyeOpen, setShowEyeOpen] = useState(true);
  const [inputType, setInputType] = useState("password");

  const { values, errors, handleChange, handleSubmit } = useFormGeneric(loginCallback, validate, initialData);

  function loginCallback() {
    const id_generated = nanoid();

    const dateNow = new Date();

    const yearFormat = dateNow.getFullYear();
    const monthFormat = formatToTwoDigits(dateNow.getMonth() + 1);
    const dayFormat = formatToTwoDigits(dateNow.getDate());
    const hoursFormat = formatToTwoDigits(dateNow.getHours());
    const minutesFormat = formatToTwoDigits(dateNow.getMinutes());
    const secondsFormat = formatToTwoDigits(dateNow.getSeconds());

    const varDateFormat = yearFormat + monthFormat + dayFormat + hoursFormat + minutesFormat + secondsFormat;

    dispatch(startLogin_Unified(values.email, values.password, id_generated + varDateFormat, navigate));

  }

  const handleOnEyeClick = () => {
    if (inputType === "password") {
      setInputType("text");
      setShowEyeOpen(false);
    }
    else {
      setInputType("password");
      setShowEyeOpen(true);
    }
  }

  return (
    <section className="gradient-custom-sky">
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5 login-card">
            <div className="card bg-color2 borderR2 text-white">
              <form onSubmit={handleSubmit} noValidate>
                <div className="card-body p-5 text-center">
                  <div className="mb-md-5 mt-md-4 pb-5">
                    <h2 className="fw-bold mb-2 text-uppercase">{t("login.screen.title")}</h2>
                    <p className="text-white-50 mb-5">{t("login.screen.message")}</p>

                    <div className="form-outline form-white mb-4">
                      <label className="form-label" htmlFor="typeEmailX">
                        {t("login.screen.email")}
                      </label>
                      <input
                        type="email"
                        id="typeEmailX"
                        className={`form-control form-control-lg ${errors.email && "is-invalid"}`}
                        autoComplete="off"
                        name="email"
                        onChange={handleChange}
                        value={values.email || ""}
                        required
                      />
                      {errors.email && <pre><p className="text-error">{errors.email}</p></pre>}
                    </div>

                    {/*<input autoComplete="off" className={`input ${errors.email && 'is-danger'}`} type="email" name="email" onChange={handleChange} value={values.email || ''} required />*/}

                    <div className="form-outline form-white mb-4">
                      <label className="form-label" htmlFor="typePasswordX">
                        {t("login.screen.password")}
                      </label>
                      <div className="group-input-icon">
                        <input

                          type={inputType}
                          id="typePasswordX"
                          className={`form-control form-control-lg ${errors.password && "is-invalid"}`}
                          name="password"
                          onChange={handleChange}
                          value={values.password || ""}
                          required
                        />
                        <i onClick={handleOnEyeClick} className={`icon-eye fa ${showEyeOpen ? "fa-eye-slash" : "fa-eye"}`}></i>
                      </div>
                      {errors.password && <pre><p className="text-error">{errors.password}</p></pre>}
                    </div>

                    <p className="small mb-5 pb-lg-2">
                      <Link to="/forgot-password" className="text-white-50 fw-bold">{t("login.screen.forgot-password")}</Link>
                    </p>

                    <button className="btn btn-outline-light btn-lg px-5" type="submit">
                      {t("login.screen.button")}
                    </button>

                    {/*
                    <div className="d-flex justify-content-center text-center mt-4 pt-1">
                      <a href="#!" className="text-white">
                        <i className="fab fa-facebook-f fa-lg"></i>
                      </a>
                      <a href="#!" className="text-white">
                        <i className="fab fa-twitter fa-lg mx-4 px-2"></i>
                      </a>
                      <a href="#!" className="text-white">
                        <i className="fab fa-google fa-lg"></i>
                      </a>
                    </div>
                    */}
                  </div>

                  <div>
                    <p className="mb-0">
                      {t("login.screen.do-not-have-an-account-yet")}
                      <Link to="/sign-up" className="text-white-50 fw-bold">{t("login.screen.register.link")}</Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginOneColumn;
